const koLang = {
  header: {
    setting: '설치',
    fullScreen: '전체 스크린',
    exitFullscreen: '전체 화면 종료',
    userCenter: '개인 센터',
    logout: '계정 종료',
    langLabel: '언어',
    zhTip: '중국어',
    enTip: '영어',
    jaTip: '일본어',
    koTip: '한국어'
  },
  home: {
    welcome: '비익 배경 관리 시스템 템플릿을 환영합니다',
    versionDoc: '새 버전 문서 설명'
  }
}

export default koLang
